import React from 'react';
import './Faqs.css';

const faqData = [
  {
    question: "What’s included when I sign up for the Intensive Interview Package?",
    answer:
      "Before your sessions, you'll receive a comprehensive set of materials to support your preparation. This includes an onboarding questionnaire, instructional videos, worksheets, a list of interview questions, and detailed debrief notes from your mock interviews.",
  },
  {
    question: "What will I receive if I sign up for a single coaching session?",
    answer:
      "You'll receive an onboarding questionnaire designed to help me understand your goals and tailor the session to make it as productive and focused as possible.",
  },
  {
    question: "How much coaching do you recommend?",
    answer:
      "In my experience, dedicating around 3 to 4 hours to coaching tends to be very effective for most people. This allows enough time to build confidence, refine your responses, and work through key scenarios.",
  },
  {
    question: "Can I begin coaching before my interview is scheduled?",
    answer:
      "100%. The earlier you start, the better prepared you’ll be. Many clients begin coaching before securing an interview so they’re ready when the opportunity arises.",
  },
  {
    question: "When are your coaching sessions available?",
    answer:
      "I offer flexible scheduling to meet your needs—sessions are available during the day, in the evenings, and on weekends.",
  },
  {
    question: "When can I expect a response to my coaching inquiry?",
    answer:
      "I respond to inquiries within 24 hours.",
  },
  {
    question: "Can you guarantee that I’ll get hired?",
    answer:
      "While no interview coaching service can guarantee a job offer, I’m fully committed to helping you improve your interview skills. With proven strategies and personalized guidance, my goal is to significantly increase your chances of success.",
  },
];

function Faqs() {
  return (
    <div className="faq-container">
      <h1 className="faq-heading">Frequently Asked Questions</h1>
      <div className="faq-list">
        {faqData.map((faq, index) => (
          <div key={index} className="faq-item">
            <h3 className="faq-question">Q: {faq.question}</h3>
            <p className="faq-answer">A: {faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Faqs;